import type { LogLevel } from '../types/LogLevel';
import { LOG_LEVELS } from './LOG_LEVELS';

export const LEVEL_PRIORITY: Record<LogLevel, number> = {
  [LOG_LEVELS.NONE]: -1,
  [LOG_LEVELS.DEBUG]: 0,
  [LOG_LEVELS.INFO]: 1,
  [LOG_LEVELS.WARN]: 2,
  [LOG_LEVELS.ERROR]: 3,
};
